module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_rectangular_marco_comida_35.62ed5fe1.png";